export default "__VITE_ASSET__D$cbMD7$__"